module.exports = __webpack_public_path__ + "media/images/header__bg-522ad9855a084b4a8ca4676ec9f04b64.jpg";